import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import DownloadIcon from '@assets/icon/download.svg';
import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Link from '@components/Link';

export interface PolicyDocumentProps {
  theme?: ITheme;
  margin: string | number;
  url: string;
}

function PolicyDocument({ margin, url }: PolicyDocumentProps) {
  const theme = useTheme();
  return (
    <ContainerBlock
      borderTop={`3px solid ${theme.colors.primary}`}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      background={theme.colors.grey[200]}
      padding={20}
      paddingTablet="20px 30px"
      margin={margin}
    >
      <Heading margin="0 0 20px" color={theme.colors.grey[400]} variant="smallTitle" fontWeight={600}>Product summary</Heading>
      <Link icon={DownloadIcon} text="Product summary" slotIcon="start" target="_blank" rel="noopener noreferrer" url={url} />
    </ContainerBlock>
  );
};

PolicyDocument.defaultProps = {
  margin: "0 0 30px",
  url: ''
}

export default PolicyDocument;
